/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class InfiniteScrollDirective {

    public scope = true;
    public restrict = 'A';

    constructor(private $rootScope: ng.IRootScopeService,
                private $window,
                private $timeout) {
    }

    public link = (scope: ng.IScope, elem, attrs) => {
        var checkWhenEnabled, handler, scrollDistance, scrollEnabled;
        let $window = angular.element(this.$window);
        let $rootScope = this.$rootScope;
        scrollDistance = 0;
        if (attrs.infiniteScrollDistance != null) {
            scope.$watch(attrs.infiniteScrollDistance, function (value: string) {
                return scrollDistance = parseInt(value, 10);
            });
        }
        scrollEnabled = true;
        checkWhenEnabled = false;
        if (attrs.infiniteScrollDisabled != null) {
            scope.$watch(attrs.infiniteScrollDisabled, function (value) {
                scrollEnabled = !value;
                if (scrollEnabled && checkWhenEnabled) {
                    checkWhenEnabled = false;
                    return handler();
                }
            });
        }
        handler = function () {
            var elementBottom, remaining, shouldScroll, windowBottom;
            windowBottom = $window.height() + $window.scrollTop();
            elementBottom = elem.offset().top + elem.height();
            remaining = elementBottom - windowBottom;
            shouldScroll = remaining <= $window.height() * scrollDistance;
            if (shouldScroll && scrollEnabled) {
                if ($rootScope.$$phase) {
                    return scope.$eval(attrs.infinitescroll);
                } else {
                    return scope.$apply(attrs.infinitescroll);
                }
            } else if (shouldScroll) {
                return checkWhenEnabled = true;
            }
        };
        $window.on('scroll', handler);
        scope.$on('$destroy', function () {
            return $window.off('scroll', handler);
        });
        return this.$timeout((function () {
            if (attrs.infiniteScrollImmediateCheck) {
                if (scope.$eval(attrs.infiniteScrollImmediateCheck)) {
                    return handler();
                }
            } else {
                return handler();
            }
        }), 0);
    };

    public static DirectiveFn($rootScope: ng.IRootScopeService,
                              $window: any,
                              $timeout: any) {
        return new InfiniteScrollDirective($rootScope, $window, $timeout);
    }

}

InfiniteScrollDirective.DirectiveFn.$inject = ['$rootScope', '$window', '$timeout'];

angular.module('beneple.global').directive('infinitescroll', InfiniteScrollDirective.DirectiveFn);



// WEBPACK FOOTER //
// ./frontend/scripts/global/directives/infinite-scroll.directive.ts